<!--
 * @Description: 学生 详情 奖励信息
 * @Author: PF
 * @Date: 2023-11-30 10:50:08
 * @LastEditors: PF
 * @LastEditTime: 2025-07-18 13:39:26
-->
<template>
  <div class="hp100" v-if="tableData.length">
    <el-table :data="tableData" border height="100%" :span-method="spanMethod">
      <el-table-column label="学期" prop="xqmc" align="center" />
      <el-table-column label="奖励名称" prop="jlmc" align="center" />
      <el-table-column label="奖励级别" prop="jljbbt" min-width="150" align="center" />
      <el-table-column label="获奖类别" prop="hjlbbt" align="center" />
      <!-- 冻结列-Right BEGIN -->
      <el-table-column label="操作" width="80" fixed="right" align="center">
        <template #default="scope">
          <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
        </template>
      </el-table-column>
      <!-- 冻结列-Right END -->
    </el-table>
  </div>
  <el-empty v-else class="hp100" description="暂无信息" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, defineProps, watch, computed } from 'vue'
import { loadSelect } from '@/api/common.js'
import { getRowspanMethod } from '@/utils/index.js'
import detail from '@/pages/jiaowu/xuejiguanli/xuejiyidong/detail.vue'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref([])

const spanMethod = computed(() =>
  getRowspanMethod(tableData.value, ['xqmc'])
)
watch(
  () => props.row,
  () => {
    if (props.row) {
      loadSelect({ url: '/api/v2/xuesheng/xueshengjiangli/list', data: tableData, parms: { xsid: props.row.id, order: 'xqmc', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
const row = ref({})
const openDetail = ref(false)
</script>
